import { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useSession } from "src/context/SessionContext";
import Loading from "../Loading/Loading";

type ProtectedRouteProps = {
  children: JSX.Element;
};
const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { session, loading } = useSession();

  if (loading) {
    return <Loading />;
  }

  if (!session) {
    return <Navigate to={`/login`} replace />;
  }

  return children;
};

export default ProtectedRoute;
